// assets/mox-email-validate.js

// --- Validación de email por expresión regular (solo sintaxis) ---
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form[data-mox-email-form]');
  if (!forms.length) return;

  // Regex más robusta:
  // - local-part: 1-64 chars permitidos por RFC (simplificado)
  // - dominio: labels de 1-63 chars alfanumérico o guion, separados por puntos
  // - ningún label puede empezar o terminar en guion
  // - TLD: solo letras, mínimo 2
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@(?!-)(?:[A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,}$/;

  forms.forEach((form) => {
    // evitar doble wiring si el DOM se rehidrata, etc.
    if (form._moxEmailWired) return;
    form._moxEmailWired = true;

    const emailInput =
      form.querySelector('[data-mox-email-input]') ||
      form.querySelector('input[type="email"]');

    if (!emailInput) return;

    const errorSpan = form.querySelector('[data-mox-email-error]');

    // localizar el botón de submit principal del form
    const submitBtn = (function () {
      const allButtons = Array.from(form.querySelectorAll('button'));
      // tomamos el primer botón que NO sea type="button" (es decir, submit o sin type)
      return (
        allButtons.find((b) => {
          const t = (b.getAttribute('type') || '').toLowerCase();
          return t !== 'button';
        }) || null
      );
    })();

    function showError(msg) {
      if (errorSpan) {
        errorSpan.textContent = msg;
      } else {
        // fallback mínimo si no han puesto contenedor de error
        alert(msg);
      }
      try {
        emailInput.setCustomValidity(msg || '');
      } catch (_) {}
    }

    function clearError() {
      if (errorSpan) {
        errorSpan.textContent = '';
      }
      try {
        emailInput.setCustomValidity('');
      } catch (_) {}
    }

    // Chequeo adicional de dominio (forma, no existencia real)
    function isDomainShapeOk(email) {
      const parts = email.split('@');
      if (parts.length !== 2) return false;
      const domain = parts[1];

      const labels = domain.split('.');
      if (labels.length < 2) return false;

      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        // sin labels vacíos
        if (!label) return false;
        // no empezar ni terminar en guion
        if (label.startsWith('-') || label.endsWith('-')) return false;
      }

      // TLD solo letras, mínimo 2
      const tld = labels[labels.length - 1];
      if (!/^[A-Za-z]{2,}$/.test(tld)) return false;

      return true;
    }

    // habilita / deshabilita el botón según validez del form + email
    function updateButtonState() {
      if (!submitBtn) return;

      const value = (emailInput.value || '').trim();
      let formOk = true;

      try {
        formOk = form.checkValidity();
      } catch (_) {
        formOk = true;
      }

      const emailOk =
        !!value && emailRegex.test(value) && isDomainShapeOk(value);

      // Solo habilitamos si TODO el form es válido y el email pasa la regex+dominio
      submitBtn.disabled = !(formOk && emailOk);
    }

    // BLUR del email → validar sintaxis y mostrar mensaje si está mal
    emailInput.addEventListener('blur', () => {
      const value = (emailInput.value || '').trim();

      clearError();

      if (!value) {
        // campo vacío: que lo maneje el required (form.checkValidity)
        updateButtonState();
        return;
      }

      if (!emailRegex.test(value) || !isDomainShapeOk(value)) {
        const msg = 'Por favor ingresa un correo electrónico válido.';
        showError(msg);
        try {
          if (typeof emailInput.reportValidity === 'function') {
            emailInput.reportValidity();
          }
        } catch (_) {}
      }

      updateButtonState();
    });

    // Cualquier input/change en el form vuelve a evaluar el estado del botón
    form.addEventListener(
      'input',
      () => {
        clearError(); // si el usuario corrige, limpiamos el mensaje
        updateButtonState();
      },
      true
    );
    form.addEventListener(
      'change',
      () => {
        updateButtonState();
      },
      true
    );

    // SUBMIT → bloquear si formato inválido + marcar flags de login/registro
    form.addEventListener('submit', (event) => {
      const value = (emailInput.value || '').trim();

      // Si otro handler anterior ya canceló el submit, no hacemos nada
      if (event.defaultPrevented) return;

      // Validar formato de correo ANTES de enviar
      if (!value || !emailRegex.test(value) || !isDomainShapeOk(value)) {
        event.preventDefault();
        const msg = 'Por favor ingresa un correo electrónico válido.';
        showError(msg);
        try {
          if (typeof emailInput.reportValidity === 'function') {
            emailInput.reportValidity();
          }
        } catch (_) {}
        emailInput.focus();
        updateButtonState();
        return;
      }

      clearError();

      // En este punto el email tiene formato válido; marcamos flags
      const formId = form.getAttribute('id') || '';

      // registro
      if (formId.indexOf('create-customer') !== -1) {
        try {
          sessionStorage.setItem('mox_register_pending', '1');
        } catch (_) {}
      }

      // login
      if (formId.indexOf('customer-login') !== -1) {
        try {
          sessionStorage.setItem('mox_login_success', '1');
        } catch (_) {}
      }

      // dejamos que el submit siga normal
    });

    // Estado inicial: botón disabled hasta que haya datos válidos
    updateButtonState();
  });
});
